import React, { ReactNode } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';

import { ArrowRightIcon } from '@features/ui/Icons';





const SwitchSalesMode = () => {
    const moduleName = 'switchSalesMode';
    return (
        <div className={cN(moduleName, styles[moduleName])}>
            <div className={styles.wrap}>
                <a
                    className={styles.more}
                    href={`${window.location.origin}${window.location.pathname}/signoutsalesmode`}
                >
                    {`登出業務模式`}
                    <ArrowRightIcon />
                </a>
            </div>
        </div>
    );
};

export default SwitchSalesMode;